<template>
    <v-card :class="styles.cardClass" :color="styles.cardColor" :elevation="styles.elevation">
        <div :class="styles.innerCard">
            <span :class="styles.dialogTitle" v-if="styles.dialogTitle != ''">{{dialogTitle}}</span>
            <div :class="styles.textWrapper">
                <div class="dialog-table">
                    <div class="dialog-row" v-for="(data, dataIndex) in item.lines" :key="dataIndex">
                        <div class="dialog-col pr-1">
                            <div v-if="layout == 'BESD2' || layout == 'DD1'" :class="speakerNameClass(dataIndex, styles.dialogName)"
                                @focusout="onEditableChange('name', dataIndex)"
                                :contenteditable="editableContent"
                                v-html='data.name.replace(/font-size: [^;]+;/g, "")'
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-${dataIndex}-name`"
                            >
                           </div>
                             <span v-else :class="speakerNameClass(dataIndex, styles.dialogName)"
                                @focusout="onEditableChange('name', dataIndex)"
                                :contenteditable="editableContent"
                                v-html='data.name.replace(/font-size: [^;]+;/g, "")'
                                @paste="filterPastedContent"
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-${dataIndex}-name`"
                            >
                           </span>
                        </div>
                        <div class="dialog-col" :class="adjustedClass" :style="adjustedStyle">
                            <span :style="styles.custom.text" :class="styles.custom.textClass" class="responsive-text"
                                @focusout="onEditableChange('dialog', dataIndex)"
                                :contenteditable="editableContent"
                                @paste="filterPastedContent"
                                v-html='layout == "BD1" ? data.dialog.replace(/font-size: [^;]+;/g, "").replace(/font-family: [^;]+;/g, "") : data.dialog.replace(/font-size: [^;]+;/g, "")'
                                :id="`${indexes.element}-${indexes.column}-${indexes.data}-${dataIndex}`"
                            >
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- dialog options  -->
            <div v-if="pageType == 'Canvas'" class="text-center mt-10">
                <v-btn small dense color="error" class="mr-1" @click="toggleDialogLines('remove', indexes)" >Remove Last</v-btn>
                <v-btn small dense color="success" @click="toggleDialogLines('add', indexes)">Add a Line</v-btn>
            </div>
        </div>
    </v-card>
</template>

<script>

export default {
    props: ["item", "indexes", "styles"],
    computed: {
        adjustedClass () {
            return this.layout == "GME" ? "pl-1" : ""
        },
        adjustedStyle () {
            return this.layout == "FSIC1" ? "overflow-wrap:anywhere" : ""
        },

        dialogTitle () {
            const letter = ["A", "B", "C", "D", "E", "F"]

            if (this.layout == "Milestone1") {
                return `Dialogue ${letter[this.indexes.data - 1]}`
            }

            return "Dialogue"
        }

    },
    methods: {
        onEditableChange (type, lineIndex) {
            const newIndexes = this.indexes
            newIndexes.line = lineIndex
            this.columnEditableData("dialog2", newIndexes, type)
        },

        speakerNameClass (dataIndex, style) {
            var customClass = ""
            if (this.layout == "GME") {
                if (dataIndex % 3 == 0) {
                    return dataIndex % 2 == 0 ? style + " gme-speaker1" : style + " gme-speaker2"
                }
                else {
                    return (dataIndex - 1) % 2 == 0 ? style + " gme-speaker1" : style + " gme-speaker2"
                }
            }
            if (this.layout == "DD1") {
                if (dataIndex % 2 == 1) {
                    customClass = "mb-5"
                }
                return dataIndex % 4 == 0 || dataIndex % 4 == 1 ? style + " dd-speaker1 " + customClass : style + " dd-speaker2 " + customClass
            }
            if (this.layout == "SP") {
                return dataIndex % 2 == 0 ? style + " sp-speaker1" : style + " sp-speaker2"
            }
            if (this.layout == "BESD2") {
                if (dataIndex % 2 == 1) {
                    customClass = "mb-5"
                }
                return dataIndex % 4 == 0 || dataIndex % 4 == 1 ? style + " besd-speaker1 " + customClass : style + " besd2-speaker2 " + customClass
            }

            if (this.layout == "TE") {
                return dataIndex % 4 == 0 || dataIndex % 4 == 1 ? style + " te-speaker1" : style + " te-speaker2"
            }
            return style
        }
    }
}
</script>

<style scoped>
    .gme-speaker1 {
        color: #595cff;
    }

    .gme-speaker2 {
        color: #129490;
    }

    .dd-speaker1 {
        color: #4ea8de;
    }

    .dd-speaker2 {
        color: #06d6a0;
    }

    .sp-speaker1 {
        color: #00c482;
    }

    .sp-speaker2 {
        color: #0061ff;
    }

    .besd-speaker1 {
        color: #ff9f1c;
    }

    .besd2-speaker2 {
        color: #e07a5f;
    }

    .te-speaker1 {
        color: #f2482f;
    }

    .te-speaker2 {
        color: #2d5362;
    }

    .dialog-table{
        display: table;
    }

    .dialog-table .dialog-row{
         display: table-row;
    }

    .dialog-table .dialog-col {
        display: table-cell;
        text-align: left;
        vertical-align: top;
     }

    .besd-card {
        border-top: 10px solid #06d6a0 !important;
    }

    .dialogue-label-a {
        color: #ff9f1c;
    }

    .dialogue-label-b {
        color: #e07a5f;
    }
    .ppja-bg {
        background: linear-gradient(to right top, #7bdff2, #c2f0f9);
    }

    .business-process-inner-card {
        border: 5px solid #000000;
    }

    .dd1-label-a {
        color: #4ea8de;
    }

    .dd2-label-b {
        color: #06d6a0;
    }
    .travel-english-name {
        color: #f2482f;
    }

    .perfect-reading-box {
        width: 100%;
        background: #fff;
        padding: 3rem;
        text-align: center;
        font-weight: 900;
        color: #000;
        font-family: arial;
        position: relative;
        border-radius: 20px;
        box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.75);
        -webkit-box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.75);
    }

    .perfect-reading-box.sb3::before {
        content: "";
        width: 0px;
        height: 0px;
        position: absolute;
        border-left: 10px solid #fff;
        border-right: 10px solid transparent;
        border-top: 10px solid #fff;
        border-bottom: 10px solid transparent;
        left: 19px;
        bottom: -19px;
    }

    .hd1-dark-blue {
        color: #003f8c;
    }
    .hd1-lighter-blue {
        color: #6edbf4;
    }

    /* .gme-label1 {
        color: #595cff;
    } */

    .milestone-card {
        background-color: #E2F2FF;
    }

    .milestone-border{
        border-radius: 20px !important;
        border: 3px solid #169bd6 !important;
    }

    .responsive-text {
        font-size: min(4.5vw, 1.3rem) !important;
    }

    .sp-dialog{
         border: 10px solid;
        border-image-slice: 1;
        border-width: 5px;
        border-image-source: linear-gradient(to right top, #00ff87, #60efff);
    }

    .emailing-highlighted-string-white {
        background: linear-gradient(to top, #ffffff 50%, #fee141 50%);
    }

    .bpn-highlighted-string-white{
        background: linear-gradient(to top, #ffffff 50%, #40D0FE 50%);
    }

    .bpp-highlighted-string-white{
        background: linear-gradient(to top, #ffffff 50%, #FF9F1C 50%);
    }

</style>
